import { useState } from "react";

import ManageSkills from "./ManageSkills";
import ManageCompanies from "./ManageCompanies";
import ManageShifts from "./ManageShifts";
import ManageRoles from "./ManageRoles";
import Managelocation from "./Managelocation";
import ManageMasterSubDepartment from "./ManageMasterSubDepartment"
import ManageMasterDepartment from "./ManageMasterDepartment";
import ManageAccessories from "./ManageAccessories";

const SECTIONS = [
  { id: "locations", label: "Manage Locations",  component: Managelocation },
  { id: "skills", label: "Manage Skills", component: ManageSkills },
  { id: "companies", label: "Manage Companies", component: ManageCompanies },
  { id: "masterdepartment", label: "Manage Master Departments", component: ManageMasterDepartment },
  { id: "mastersubdepartment", label: "Manage Master SubDepartments", component: ManageMasterSubDepartment },
  { id: "roles", label: "Manage Departments", component: ManageRoles },
  { id: "shifts", label: "Manage Shifts", component: ManageShifts },
 
  
  { id: "accessories", label: "Manage Essentials", component: ManageAccessories },

];

export default function Metadatapage() {
  const [active, setActive] = useState("locations");

  const ActiveComponent = SECTIONS.find((s) => s.id === active)?.component;

  return (
    <div className="p-6 min-h-screen bg-gray-50">

<h1 className="text-2xl font-bold mb-4 text-center pt-16 pb-4">Manage Metadata</h1>


      <div className="flex gap-2 border-b mb-6 ml-16">
        {SECTIONS.map((s) => (
          <button
            key={s.id}
            onClick={() => setActive(s.id)}
            className={`pb-2 text-sm font-medium mx-3 ${
              active === s.id
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-gray-500"
            }`}
          >
            {s.label}
          </button>
        ))}
      </div>

      {/* Active Tab Content */}
      <div className="mx-12">
        {ActiveComponent && <ActiveComponent />}
      </div>

    </div>
  );
}